export default {
    delete_sms_system_title: "Delete SMS System",
    delete_sms_system_success_message: "The SMS System has been deleted",
    delete_sms_system_error_message: "It is not possible to delete the SMS System",
    delete_sms_system_label: "Are you sure you want to delete the SMS System?",
}